const { LASSO_HOME_URL, VUE_APP_API_BASE_URL } = process.env;

export default {
  API_BASE_URL: VUE_APP_API_BASE_URL || 'http://localhost:3000/v1',
  LASSO_HOME_URL: LASSO_HOME_URL || 'https://www.lasso.io/',
};
